import Dummy from './Dummy';

export default Dummy;
